import {
  Facebook,
  Instagram,
  Linkedin,
  Mail,
  MapPin,
  Phone,
} from 'lucide-react'

export const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-50 border-t pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {/* Brand Column */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <img
                src="https://lh3.googleusercontent.com/d/11qfTcyfnVltxzRDy1iALp4ZnMJpL8k9r"
                alt="Transbio Logo"
                className="h-[52px] w-auto object-contain"
              />
            </div>
            <p className="text-sm text-gray-600 leading-relaxed max-w-xs">
              Especialistas em gerenciamento de resíduos de serviços de saúde.
              Segurança, agilidade e responsabilidade ambiental.
            </p>
            <div className="flex gap-4 pt-2">
              <a
                href="#"
                className="text-gray-400 hover:text-primary transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-primary transition-colors"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-primary transition-colors"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-semibold text-gray-900 mb-4">
              Links Rápidos
            </h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>
                <a
                  href="#hero"
                  className="hover:text-primary transition-colors"
                >
                  Início
                </a>
              </li>
              <li>
                <a
                  href="#services"
                  className="hover:text-primary transition-colors"
                >
                  Serviços
                </a>
              </li>
              <li>
                <a
                  href="#process"
                  className="hover:text-primary transition-colors"
                >
                  Como Funciona
                </a>
              </li>
              <li>
                <a
                  href="#cep-checker"
                  className="hover:text-primary transition-colors"
                >
                  Área de Atuação
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="hover:text-primary transition-colors"
                >
                  Contato
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading font-semibold text-gray-900 mb-4">
              Contato
            </h3>
            <ul className="space-y-3 text-sm text-gray-600">
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-primary shrink-0 mt-1" />
                <span>
                  Rua Pedro Rodrigues de Oliveira, 136 - Sala 102. Montanha-ES
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-primary shrink-0" />
                <a
                  href="tel:+5527999205884"
                  className="hover:text-primary transition-colors"
                >
                  (27) 99920-5884
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-primary shrink-0" />
                <a
                  href="mailto:atendimento.transbio@gmail.com"
                  className="hover:text-primary transition-colors"
                >
                  atendimento.transbio@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500">
          <p>&copy; {currentYear} Transbio. Todos os direitos reservados.</p>
          <p>CNPJ: 18.058.994/0001-62</p>
          <p>Desenvolvido com excelência.</p>
        </div>
      </div>
    </footer>
  )
}
